import { logger } from '../utils/logger';
import api from '../api/api';
import { toast } from 'react-toastify';
import { CalificacionDocumento } from '../types/CalificacionDocumento';
import { ObservacionHabilitacion } from '../types/ObservacionHabilitacion';

export const useCalificacionHabilitacion = () => {
    const DOC_URL = 'documentos-habilitacion';
    const DOC_PERSONAL_URL = 'doc-personal-habcontratista';
    const HAB_URL = 'habilitacion-contratista';
    const OBS_URL = 'observacion-habilitacion';

    const handleError = (error: any, fallback: string) => {
        const msg = error?.response?.data?.message ?? fallback;
        toast.error(msg);
        logger.error(error);
    };

    const calificarDocumento = async (
        idDocumento: number,
        status: string,
        observacion: string
    ) => {
        const body: CalificacionDocumento = { status, observacion };
        try {
            const response = await api.put(
                `${DOC_URL}/${idDocumento}/calificar`,
                body
            );
            return response.data;
        } catch (error) {
            handleError(error, 'No se pudo calificar el documento');
            throw error;
        }
    };

    const calificarDocumentoPersonal = async (
        idDocumento: number,
        status: string,
        observacion: string
    ) => {
        const body: CalificacionDocumento = { status, observacion };
        try {
            const response = await api.put(
                `${DOC_PERSONAL_URL}/${idDocumento}/calificar`,
                body
            );
            return response.data;
        } catch (error) {
            handleError(error, 'No se pudo calificar el documento del personal');
            throw error;
        }
    };

    const getDocumentosConCalificacion = async (idHabilitacion: number) => {
        try {
            const response = await api.get(
                `${DOC_URL}/habilitacion/${idHabilitacion}/calificaciones`
            );
            return response?.data ?? [];
        } catch (error) {
            handleError(error, 'No se pudieron obtener los documentos');
            return [];
        }
    };

    const setEstadoTemporal = async (
        idHabilitacion: number,
        idTipoEstadoSiguiente: number
    ) => {
        try {
            const response = await api.put(
                `${HAB_URL}/${idHabilitacion}/estado-temporal`,
                { idTipoEstadoSiguiente }
            );
            return response.data;
        } catch (error) {
            handleError(error, 'No se pudo guardar el estado siguiente');
            throw error;
        }
    };

    const getEstadosSiguientes = async (idHabilitacion: number) => {
        try {
            const response = await api.get(
                `${HAB_URL}/${idHabilitacion}/estados-siguientes`
            );
            return response?.data ?? [];
        } catch (error) {
            handleError(error, 'No se pudieron obtener los estados siguientes');
            return [];
        }
    };

    const saveObservacionHabilitacion = async (
        observacion: ObservacionHabilitacion
    ) => {
        try {
            const response = await api.post(`${OBS_URL}`, observacion);
            return response.data;
        } catch (error) {
            handleError(error, 'No se pudo guardar la observación');
            throw error;
        }
    };

    const getObservacionActual = async (idHabilitacion: number) => {
        try {
            const response = await api.get(
                `${OBS_URL}/habilitacion/current/${idHabilitacion}`
            );
            return response?.data ?? null;
        } catch (error) {
            handleError(error, 'No se pudo obtener la observación actual');
            return null;
        }
    };

    const enviarHabilitacion = async (idHabilitacion: number) => {
        try {
            const response = await api.get(`${HAB_URL}/send/${idHabilitacion}`);
            return response.data;
        } catch (error) {
            handleError(error, 'No se pudo enviar la habilitación');
            throw error;
        }
    };

    return {
        calificarDocumento,
        calificarDocumentoPersonal,
        getDocumentosConCalificacion,
        setEstadoTemporal,
        getEstadosSiguientes,
        saveObservacionHabilitacion,
        getObservacionActual,
        enviarHabilitacion,
    };
};
